import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import it from "vuetify/es5/locale/it";
import VueI18n from "vue-i18n";
import { messages } from "Lang/messages.js";

Vue.use(Vuetify);
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: "it", // set locale
    fallbackLocale: "it",
    messages: messages,
});

const vuetify = new Vuetify({
    lang: {
        locales: { it },
        current: "it",
    },
    //theme: {
    //    dark: false,        
    //},
});

const Currency = {
    install(Vue) {
        Vue.prototype.$currency_str = (currency) => {
            if (currency && i18n.te("currencyCode." + currency)) {
                return i18n.t("currencyCode." + currency);
            } else if (currency && !i18n.te("currencyCode." + currency)) {
                return currency;
            } else {
                return i18n.t("currencyCode.default");
            }
        };
    },
};

Vue.use(Currency);

export { i18n, vuetify, Currency };
